import Vue from 'vue'
import App from './App.vue'
import './plugins/element.js'

import router from './router'
import store from './store'; // 引入 store

import Vant from 'vant';
import 'vant/lib/index.css';


Vue.config.productionTip = false

Vue.use(Vant); // 使用 Vue.use 方法来注册 Vant

new Vue({
  store, // 将 store 添加到 Vue 实例中
  render: h => h(App),
  router
}).$mount('#app')
